import { useTranslation } from 'react-i18next';
import { useGlobal } from '../../Core/GlobalState/Store';
import Currencies from '../../Core/Enums/Currencies';
import DateService from '../../Core/Services/DateService';
import { formatPrice, addVat } from '../../Core/Services/PaymentService';

const formatter = new Intl.DateTimeFormat('da-DK', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const BookingSummary = ({ firstMonthPrice, showAutoRenew = false }) => {
  const { t, i18n } = useTranslation();
  const { selectedSize, currentLocation, room, date } = useGlobal();

  const dateTo = DateService.getEndOfFirstBillingPeriod(date);
  const currency = Currencies.getCodeByValue(room.SelfStoreMonthPriceUniCurrency);

  return (
    <div className="p-8 flex flex-col gap-4 !border !border-solid border-borderblue mt-2 md:mt-0">
      <div
        className="font-medium text-sm"
        style={{ color: '#233F72', fontFamily: 'Roboto' }}
      >
        {t('summary')}
      </div>
      <div>
        {selectedSize?.images?.[0] && (
          <img
            src={selectedSize.images[0]}
            alt={selectedSize.title}
            className="w-full"
            style={{ borderRadius: '8px' }}
          />
        )}
        <div className="flex justify-between">
          <span className="font-bold text-base mt-6">{selectedSize?.title}</span>
          <span className="font-bold text-base mt-6">
            {(selectedSize?.length * selectedSize?.width).toFixed(2)} m²
          </span>
        </div>
        <div className="!mt-6 font-bold mb-6">
          <div>
            {t('location')}: {currentLocation?.address}
          </div>
        </div>
        <hr />
        <div className="!mt-6 flex justify-between">
          <div className="font-bold text-base">{t('first_month')}</div>
          <div className="font-bold text-base">
            {formatPrice(firstMonthPrice, i18n.language)} {currency}. {t('incl_vat')}
          </div>
        </div>
        <div className="text-sm mt-1 mb-6">
          <div>
            {t('from')} {formatter.format(date)} {t('to')}{' '}
            {formatter.format(dateTo)}
          </div>
        </div>
        <hr />
        {showAutoRenew && (
          <div className="!mt-6 flex justify-between">
            <div className="font-bold text-base">{t('auto_renew')}</div>
            <div className="font-bold text-base">
              {formatPrice(addVat(room.SelfStoreMonthPrice), i18n.language)}{' '}
              {currency}. {t('incl_vat')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingSummary;
